import { render, staticRenderFns } from "./PictureV1Properties.vue?vue&type=template&id=923099c8&"
import script from "./PictureV1Properties.vue?vue&type=script&lang=js&"
export * from "./PictureV1Properties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../Breeze.Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports